import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import extraReducers from '../../extraReducers/uploadFileExtraReducer';

const resolveUploadFile = (input: unknown): File | null => {
  if (input instanceof File) {
    return input;
  }

  if (input && typeof input === 'object') {
    const nestedFile = (input as { file?: unknown }).file;
    if (nestedFile instanceof File) {
      return nestedFile;
    }
  }

  return null;
};

const initialState = {
  data: null,
  uploadFileStatus: STATUS.NOT_STARTED,
  uploadFileMessage: '',
  uploadBulkQuestionData: null,
  uploadBulkQuestionStatus: STATUS.NOT_STARTED,
  uploadBulkQuestionMessage: ''
};


export const createUploadFile = createAsyncThunk(
  'upload/company/POST',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('upload/company/', payload);
      const { status, data } = response;
      if (status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
)

export const uploadBulkQuestions = createAsyncThunk(
  'upload/company/test/POST',
  async (payload: { id: string, selectedFile: File }, thunkAPI) => {
    const {id, selectedFile} = payload;
    try {
      const uploadFile = resolveUploadFile(selectedFile);

      if (!uploadFile) {
        return thunkAPI.rejectWithValue({ message: 'Invalid file payload' });
      }

      if (uploadFile.size <= 0) {
        return thunkAPI.rejectWithValue({ message: 'Uploaded file is empty' });
      }

      const formData = new FormData();
      formData.append('file', uploadFile);
      formData.append('project_id', id);
      formData.append('type', 'TEST');
      const response = await api.post(`project/company/test/upload`, formData);
      
      return response.data;
    } catch (error: any) {

      if (error?.response?.status === 500) {
        return thunkAPI.rejectWithValue({ message: 'Wrong Format, please download template to upload correct format.' });
      }
      return thunkAPI.rejectWithValue({ message: error?.response?.data?.message || error?.message || 'Failed to upload file' });
    }
  }
);

const addUploadFileSlice = createSlice({
  name: 'uploadFile',
  initialState,
  reducers: {
    setUploadFileStatus(state, action) {
      state.uploadFileStatus = action.payload
    },
    resetUploadFileState() {
      return initialState;
    },
    setUploadBulkQuestionStatus(state, action) {
      state.uploadBulkQuestionStatus  = action.payload;
    },
  },
  extraReducers
});

export const {setUploadFileStatus, resetUploadFileState, setUploadBulkQuestionStatus} = addUploadFileSlice.actions;
export default addUploadFileSlice.reducer;


